import { render, staticRenderFns } from "./FaqDialog.vue?vue&type=template&id=53f9a918&scoped=true"
import script from "./FaqDialog.vue?vue&type=script&lang=js"
export * from "./FaqDialog.vue?vue&type=script&lang=js"
import style0 from "./FaqDialog.vue?vue&type=style&index=0&id=53f9a918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f9a918",
  null
  
)

export default component.exports